export default "__VITE_ASSET__DzEAkEeP__"